import { Outlet } from "react-router-dom";
import RouteErrorBoundary from "@shared/ui/ErrorBoundary/RouteErrorBoundary";
import styles from "./AuthLayout.module.scss";

import Logo from "@shared/assets/icons/Logo";

export default function AuthLayout() {
  return (
    <div className={styles.authLayout}>
      <div className={styles.authLayoutImage}>
        <div className={styles.authOutlet}>
          <Logo />
          <RouteErrorBoundary>
            <Outlet />
          </RouteErrorBoundary>
        </div>
      </div>
    </div>
  );
}
